module.exports = __webpack_public_path__ + "img/favicon_196x196.eea3ef3c.png";